
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("9h83k", function(module, exports) {
// valid hex color (optional alpha channel) - 3, 4, 6, or 8 digits after the #
const $e1ab43712dd90283$var$isValidHex = (hex)=>// Not using `([a-f0-9]{3,4}){1,2}` because that allows 7 digits which is invalid
    /^#(([a-f0-9]{3,4})|([a-f0-9][a-f0-9]){3,4})$/i.test(hex);
function $e1ab43712dd90283$export$103711ef09c6edec(color) {
    if (!$e1ab43712dd90283$var$isValidHex(color)) return null;
    let channels;
    if (color.length <= 5) // Hex code is shorthand - RGB channels are one digit
    channels = {
        r: color[1].repeat(2),
        g: color[2].repeat(2),
        b: color[3].repeat(2)
    };
    else // Hex code is longhand - RGB channels are two digits
    channels = {
        r: color.slice(1, 3),
        g: color.slice(3, 5),
        b: color.slice(5, 7)
    };
    return {
        r: parseInt(channels.r, 16),
        g: parseInt(channels.g, 16),
        b: parseInt(channels.b, 16)
    };
}
module.exports["parseHex"] = $e1ab43712dd90283$export$103711ef09c6edec;

});

parcelRegister("8MTIk", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4KS7f = parcelRequire("4KS7f");


var $3gadb = parcelRequire("3gadb");


var $4qrTW = parcelRequire("4qrTW");

const $d9f8522a95eafbc1$export$f32bddcb857301f3 = ({ mode: { iconButton: iconButton } })=>(current, props)=>{
        const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = current(props);
        return {
            buttonStyles: {
                ...buttonStyles,
                borderRadius: "var(--ds-radius-full, 100%)",
                display: 'flex',
                margin: `0 ${"var(--ds-space-025, 2px)"}`,
                // TODO Delete this comment after verifying space token -> previous value `4`
                padding: "var(--ds-space-050, 4px)",
                height: 'auto',
                fontWeight: "var(--ds-font-weight-medium, 500)",
                ...iconButton.default,
                ':hover': iconButton.hover,
                ':focus': iconButton.focus,
                // :active doesn't work in FF, because we do a
                // e.preventDefault() on mouse down in Button.
                // '&&' is required to add more CSS specificity
                // && it not a valid CSSObject property
                // @ts-ignore
                '&&': {
                    ...props.state === 'active' && iconButton.active
                },
                ...props.state === 'selected' && iconButton.selected,
                '> span': {
                    margin: 0
                }
            },
            spinnerStyles: spinnerStyles
        };
    };


const $15fa71be19d9664f$export$c25acd513dcc8062 = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    const { icon: icon, label: label, testId: testId, tooltip: tooltip, component: component, href: href, id: id, isDisabled: isDisabled, isSelected: isSelected, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, target: target, theme: theme, isTooltipAnnouncementDisabled: isTooltipAnnouncementDisabled = false, ...rest } = props;
    const themeFromContext = (0, $4qrTW.useTheme)();
    const button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KS7f.default), {
        appearance: "primary",
        "aria-label": label,
        component: component,
        href: href,
        iconBefore: icon,
        id: id,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onMouseUp: onMouseUp,
        ref: ref,
        target: target,
        testId: testId,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/design-system/no-unsafe-style-overrides
        theme: theme || (0, $d9f8522a95eafbc1$export$f32bddcb857301f3)(themeFromContext),
        ...rest
    });
    if (tooltip) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: tooltip,
        hideTooltipOnClick: true,
        isScreenReaderAnnouncementDisabled: isTooltipAnnouncementDisabled
    }, button);
    return button;
});
module.exports["IconButton"] = $15fa71be19d9664f$export$c25acd513dcc8062;

});

parcelRegister("fwSxy", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");


var $afneb = parcelRequire("afneb");


var $2azjJ = parcelRequire("2azjJ");


var $6fnsQ = parcelRequire("6fnsQ");


var $bWLcG = parcelRequire("bWLcG");


var $cStGJ = parcelRequire("cStGJ");

function $90f37d6779fc16bb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $90f37d6779fc16bb$var$expandedPlaceholderColor = "var(--ds-text-subtlest, #B5BEC9)";
const $90f37d6779fc16bb$export$63e083aca343a6ae = /*#__PURE__*/ (0, $cStGJ.default)("span", {
    target: "eq4kchp13"
})("display:none;@media screen and (max-width: ", (0, $2azjJ.dialogPageTakeoverWidth), "px){display:", (props)=>props.isExpanded ? 'none' : 'block', ";}");
const $90f37d6779fc16bb$export$9673cb6b61244e6e = /*#__PURE__*/ (0, $cStGJ.default)('span', {
    target: "eq4kchp12"
})("width:", (0, $2azjJ.grid).multiple(2).px, ";height:", (0, $2azjJ.grid).multiple(2).px, ";position:absolute;top:", (0, $2azjJ.grid).px, ";left:", (0, $2azjJ.grid).px, ";color:", (props)=>props.isExpanded ? `var(--ds-text, ${0, $6fnsQ.N900})` : props.default.color, ";display:inline-flex;align-items:baseline;:focus{box-shadow:0 0 0 2px ", `var(--ds-border-focused, ${(0, $6fnsQ.B200)})`, ";border-radius:100%;outline:none;}&>span[role='img']{line-height:0;}@media screen and (max-width: ", (0, $2azjJ.dialogPageTakeoverWidth), "px){display:none;}");
const $90f37d6779fc16bb$export$1da38d078e896a10 = /*#__PURE__*/ (0, $cStGJ.default)('div', {
    target: "eq4kchp11"
})("position:absolute;display:flex;top:0;right:0;height:100%;align-items:center;margin:auto 0;@media screen and (max-width: ", (0, $2azjJ.dialogPageTakeoverWidth), "px){right:24px;}");
const $90f37d6779fc16bb$export$ff9b1a25d343474d = /*#__PURE__*/ (0, $cStGJ.default)('div', {
    target: "eq4kchp10"
})("width:", (0, $2azjJ.grid).multiple(2).px, ";height:", (0, $2azjJ.grid).multiple(2).px, ";padding:5px var(--ds-space-075, 6px);color:", `var(--ds-text-subtlest, ${(0, $6fnsQ.N70)})`, ";background-color:transparent;@media screen and (max-width: ", (0, $2azjJ.dialogPageTakeoverWidth), "px){display:none;}:hover{cursor:pointer;color:", `var(--ds-icon, ${(0, $6fnsQ.N500)})`, ";}&>span>svg{vertical-align:unset;}");
const $90f37d6779fc16bb$export$54c466678ae7c638 = /*#__PURE__*/ (0, $cStGJ.default)('div', {
    target: "eq4kchp9"
})("display:none;margin:0 ", (0, $2azjJ.grid).px, ";height:", (0, $2azjJ.grid).multiple(4).px, ";padding-bottom:", (0, $2azjJ.grid).multiple(0.25).px, ";color:", (props)=>props.default.color, ";@media screen and (max-width: ", (0, $2azjJ.dialogPageTakeoverWidth), "px){display:flex;align-items:center;}:hover{border-radius:100%;background-color:", (props)=>props.hover.backgroundColor, ";color:", (props)=>props.hover.color, ";}");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
var $90f37d6779fc16bb$var$_ref = {
    name: "1d3w5wq",
    styles: "width:100%"
};
const $90f37d6779fc16bb$export$c2b37b18a8b54130 = /*#__PURE__*/ (0, $cStGJ.default)('div', {
    target: "eq4kchp8"
})(/*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
(0, $9K4OG.css)("position:relative;max-width:100%; @media screen and (max-width: ", (0, $2azjJ.dialogPageTakeoverWidth), "px){ width:100%;}"), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>{
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
    const boundedStyles = /*#__PURE__*/ (0, $9K4OG.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        width: props.isExpanded ? (0, $2azjJ.dialogWidth) : (0, $2azjJ.collapsedSearchInputWidth)
    });
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
    const fluidStyles = $90f37d6779fc16bb$var$_ref;
    const styles = props.shouldFillContainer ? fluidStyles : boundedStyles;
    // todo - this should be another class
    if (props.isExpanded) // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $9K4OG.css)(styles, " @media screen and (max-width: ", (0, $2azjJ.dialogPageTakeoverWidth), "px){width:100%;height:", (0, $2azjJ.atlassianNavigationHeight), ";background-color:", props.default.backgroundColor, "; display:flex;align-items:center;max-width:initial;}");
    return styles;
});
const $90f37d6779fc16bb$export$b6261a2c5ea449d = /*#__PURE__*/ (0, $cStGJ.default)("input", {
    target: "eq4kchp7"
})("height:", (0, $2azjJ.inputFieldHeight).px, ";width:100%;padding:0px var(--ds-space-150, 12px) 0px 30px;box-sizing:border-box;outline:none;border-radius:5px;/* Refer to @atlaskit/textfield for more details */font:var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);", (props)=>`
    border: ${"var(--ds-border-width, 1px)"} solid ${props.isExpanded ? props.focus.borderColor : props.default.borderColor};
    box-shadow: ${props.isExpanded ? `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${props.focus.borderColor}, -12px 0 24px 0 ${props.default.backgroundColor}` : 'none'};
    background-color: ${props.isExpanded ? props.focus.backgroundColor : props.default.backgroundColor};
    color: ${props.isExpanded ? props.focus.color : props.default.color};

    &::placeholder {
      color: ${props.isExpanded ? $90f37d6779fc16bb$var$expandedPlaceholderColor : props.default.color};
    }
    :focus {
      border: ${"var(--ds-border-width, 1px)"} solid ${props.focus.borderColor};
    }
    @media screen and (max-width: ${0, $2azjJ.dialogPageTakeoverWidth}px) {
      ${props.isExpanded ? `
            padding: 0 ${(0, $2azjJ.grid).multiple(1.5).px} ${(0, $2azjJ.grid).multiple(0.25).px};
            margin: 0 ${(0, $2azjJ.grid).multiple(3).px} 0 0;` : `
            display: none;
          `}
    }
  `, " ", (0, $bWLcG.media).above.xs, "{font:var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);}");
const $90f37d6779fc16bb$export$ca6fe3402791d08e = /*#__PURE__*/ (0, $cStGJ.default)((0, $afneb.default), {
    target: "eq4kchp6"
})({
    name: "eivff4",
    styles: "display:none"
});
const $90f37d6779fc16bb$export$6d53dccb772ed720 = /*#__PURE__*/ (0, $cStGJ.default)('input', {
    target: "eq4kchp5"
})("height:", (0, $2azjJ.inputFieldHeight).px, ";width:100%;padding:0px var(--ds-space-150, 12px) 0px 30px;box-sizing:border-box;outline:none;border-radius:5px;font:var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);border:", ()=>`${"var(--ds-border-width, 1px)"} solid ${`var(--ds-border-input, ${0, $6fnsQ.N100})`}`, ";background-color:var(--ds-background-input, rgb(255, 255, 255));color:", `var(--ds-text-subtlest, ${(0, $6fnsQ.N200)})`, ";:hover{background-color:var(--ds-background-input-hovered, rgb(255, 255, 255));}:focus{color:", `var(--ds-text, ${(0, $6fnsQ.N900)})`, ";box-shadow:", ()=>`inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-input, ${0, $6fnsQ.N100})`}`, ";}@media screen and (max-width: ", (0, $2azjJ.dialogPageTakeoverWidth), "px){display:none;}");
const $90f37d6779fc16bb$export$c47d4a3e1f1297f1 = /*#__PURE__*/ (0, $cStGJ.default)('div', {
    target: "eq4kchp4"
})("position:relative;height:32px;@media screen and (min-width: 781px){min-width:", (props)=>props.shouldFillContainer ? '100%' : '200px', ";}", (props)=>props.shouldFillContainer ? 'width: 100%;' : '', ";");
const $90f37d6779fc16bb$export$58ae19ee1fc7be8a = /*#__PURE__*/ (0, $cStGJ.default)('div', {
    target: "eq4kchp3"
})({
    name: "bjn8wh",
    styles: "position:relative"
});
const $90f37d6779fc16bb$export$b40f2abde293e8e4 = /*#__PURE__*/ (0, $cStGJ.default)('div', {
    target: "eq4kchp2"
})("position:relative;max-width:100%;@media screen and (max-width: ", (0, $2azjJ.dialogPageTakeoverWidth), "px){width:100%;}width:", (props)=>{
    if (props.shouldFillContainer) return '100%';
    return 0, $2azjJ.collapsedSearchInputWidth;
}, ";");
const $90f37d6779fc16bb$export$eb4e9f55bbe045df = /*#__PURE__*/ (0, $cStGJ.default)('span', {
    target: "eq4kchp1"
})("width:", (0, $2azjJ.grid).multiple(2).px, ";height:", (0, $2azjJ.grid).multiple(2).px, ";position:absolute;top:", (0, $2azjJ.grid).px, ";left:", (0, $2azjJ.grid).px, ";color:rgb(107, 119, 140);display:inline-flex;align-items:baseline;@media screen and (max-width: ", (0, $2azjJ.dialogPageTakeoverWidth), "px){display:none;}");
const $90f37d6779fc16bb$export$3f33ed4b273b43d = /*#__PURE__*/ (0, $cStGJ.default)('span', {
    target: "eq4kchp0"
})("display:none;padding:", (0, $2azjJ.grid).multiple(0.5).px, ";padding-right:var(--ds-space-025, 2px);color:rgb(52, 69, 99);@media screen and (max-width: ", (0, $2azjJ.dialogPageTakeoverWidth), "px){display:flex;}");
module.exports["MobileSearchIconWrapper"] = $90f37d6779fc16bb$export$63e083aca343a6ae;
module.exports["DesktopSearchIconWrapper"] = $90f37d6779fc16bb$export$9673cb6b61244e6e;
module.exports["InputBoxOverlayRight"] = $90f37d6779fc16bb$export$1da38d078e896a10;
module.exports["ClearIconWrapper"] = $90f37d6779fc16bb$export$ff9b1a25d343474d;
module.exports["ArrowIconWrapper"] = $90f37d6779fc16bb$export$54c466678ae7c638;
module.exports["SearchInputContainer"] = $90f37d6779fc16bb$export$c2b37b18a8b54130;
module.exports["SearchInputField"] = $90f37d6779fc16bb$export$b6261a2c5ea449d;
module.exports["HiddenTooltip"] = $90f37d6779fc16bb$export$ca6fe3402791d08e;
module.exports["SSRsearchInputField"] = $90f37d6779fc16bb$export$6d53dccb772ed720;
module.exports["SSRsearchInputWrapper"] = $90f37d6779fc16bb$export$c47d4a3e1f1297f1;
module.exports["SSRformContainer"] = $90f37d6779fc16bb$export$58ae19ee1fc7be8a;
module.exports["SSRsearchInputContainer"] = $90f37d6779fc16bb$export$b40f2abde293e8e4;
module.exports["SSRdesktopSearchIconWrapper"] = $90f37d6779fc16bb$export$eb4e9f55bbe045df;
module.exports["SSRmobileSearchIconWrapper"] = $90f37d6779fc16bb$export$3f33ed4b273b43d;

});

parcelRegister("iSHbD", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $jluld = parcelRequire("jluld");


var $6fnsQ = parcelRequire("6fnsQ");

const $e1919834031c61bc$export$82eafebb825fc23f = ({ isExpanded: isExpanded, theme: theme, primaryColor: primaryColor = `var(--ds-text, ${0, $6fnsQ.N800})`, label: label = '' })=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jluld))), {
        label: label,
        // NOTE: color do not accept string type but here primaryColor is string, so need to use any
        color: isExpanded ? primaryColor : theme.default.color
    });
module.exports["SearchIcon"] = $e1919834031c61bc$export$82eafebb825fc23f;

});

parcelRegister("eSS4z", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $lgmus = parcelRequire("lgmus");


var $6fnsQ = parcelRequire("6fnsQ");

/**
 * Pls see the function generateTheme inside - atlassian-frontend/packages/navigation/atlassian-navigation/src/theme/themeGenerator.ts
 * This default generator should overwrite the exact same properties which are being produced by the theme generator.
 */ const $f63156beb535cb85$export$e6c62eb05a8288ed = {
    default: {
        default: {
            backgroundColor: `var(--ds-background-input, ${(0, $6fnsQ.N0)})`,
            color: `var(--ds-text-subtlest, ${(0, $6fnsQ.N200)})`,
            borderColor: `var(--ds-border-input, ${(0, $6fnsQ.N100)})`,
            borderWidth: "var(--ds-border-width, 1px)",
            iconColor: `var(--ds-icon-subtle, ${(0, $6fnsQ.N600)})`
        },
        focus: {
            borderColor: `var(--ds-border-focused, ${(0, $6fnsQ.B100)})`,
            backgroundColor: `var(--ds-background-input-pressed, ${(0, $6fnsQ.N0)})`,
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-input, ${(0, $6fnsQ.N100)})`}`
        },
        hover: {
            backgroundColor: "var(--ds-background-input-hovered, rgba(222, 235, 255, 0.9))"
        }
    }
};
const $f63156beb535cb85$var$getTheme = (searchCSS)=>{
    if (!searchCSS) return $f63156beb535cb85$export$e6c62eb05a8288ed.default;
    return (0, (/*@__PURE__*/$parcel$interopDefault($lgmus)))({}, $f63156beb535cb85$export$e6c62eb05a8288ed.default, searchCSS);
};
const $f63156beb535cb85$var$ctx = /*#__PURE__*/ (0, $42omo.createContext)($f63156beb535cb85$export$e6c62eb05a8288ed.default);
const $f63156beb535cb85$export$d8964aec282183a3 = ({ value: value, partialSearchCSS: partialSearchCSS, children: children })=>{
    const theme = $f63156beb535cb85$var$getTheme(partialSearchCSS || value);
    return /*#__PURE__*/ (0, $l998X.jsx)($f63156beb535cb85$var$ctx.Provider, {
        value: theme,
        children: children
    });
};
const $f63156beb535cb85$export$93d4e7f90805808f = ()=>{
    return (0, $42omo.useContext)($f63156beb535cb85$var$ctx);
};
// todo - deprecate (requires product update)
// eslint-disable-next-line
const $f63156beb535cb85$export$f9bb738f552c610d = $f63156beb535cb85$var$ctx;
// todo - deprecate (requires product update)
// eslint-disable-next-line
const $f63156beb535cb85$export$62640b580a501775 = (suppliedTheme)=>{
    return suppliedTheme;
};
module.exports["ThemeProvider"] = $f63156beb535cb85$export$d8964aec282183a3;
module.exports["useTheme"] = $f63156beb535cb85$export$93d4e7f90805808f;

});

parcelRegister("5bPOK", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $bQm3c = parcelRequire("bQm3c");

var $c6bf0727a21a02b6$export$2ad518e2a6db5d40 = /*#__PURE__*/ function(ExperimentParameterValues) {
    ExperimentParameterValues["CONTROL"] = "quick-find-control";
    ExperimentParameterValues["EXPERIMENT"] = "quick-find-experiment";
    ExperimentParameterValues["NOT_ENROLLED"] = "not-enrolled";
    return ExperimentParameterValues;
}({});
const $c6bf0727a21a02b6$export$b627fae0f53cc74b = 'confluence_frontend_quick_find';
const $c6bf0727a21a02b6$export$a5c820d7542f98bf = ()=>{
    const { isRovoEnabled: isRovoEnabledInTCS } = (0, $bQm3c.useSessionData)();
    // A user sees Quick Find if:
    // - They have Rovo or the FG for Unified Search beta (in development)
    // For now, the Rovo Opt Out also overrides the Unified Search FG
    // Opting out overrides all other checks
    if ((0, $9wGTI.fg)('confluence_rovo_search_opt_out')) return [
        false,
        null
    ];
    // A user sees Quick Find if:
    // - They have Rovo or the FG for Unified Search beta (in development)
    // For now, the Rovo Opt Out also overrides the Unified Search FG
    if (isRovoEnabledInTCS || (0, $9wGTI.fg)('unified_search_in_confluence')) return [
        true,
        {
            abTestId: $c6bf0727a21a02b6$export$b627fae0f53cc74b,
            controlId: "quick-find-control",
            experimentId: "quick-find-experiment"
        }
    ];
    if ((0, $6mKj3.expVal)('confluence_frontend_quick_find', 'cohort', 'not-enrolled') !== "not-enrolled") // this check ensures that we don't overwrite the /experiment API response for users who are not in the Quick Find experiment
    return [
        // today we are overriding the ab context only for quick find. In future when this becomes the standard we wouldnt need this condition
        (0, $6mKj3.expValEquals)('confluence_frontend_quick_find', 'cohort', 'quick-find-experiment'),
        {
            abTestId: $c6bf0727a21a02b6$export$b627fae0f53cc74b,
            controlId: "quick-find-control",
            experimentId: (0, $6mKj3.expVal)('confluence_frontend_quick_find', 'cohort', 'not-enrolled')
        }
    ];
    return [
        // today we are overriding the ab context only for quick find. In future when this becomes the standard we wouldnt need this condition
        (0, $6mKj3.expValEquals)('confluence_frontend_quick_find', 'cohort', 'quick-find-experiment'),
        null
    ];
};
module.exports["useQuickFindEnabled"] = $c6bf0727a21a02b6$export$a5c820d7542f98bf;

});

parcelRegister("kvBa6", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $c0qxy = parcelRequire("c0qxy");


var $dh538 = parcelRequire("dh538");


var $fG2rA = parcelRequire("fG2rA");

var $epS7s = parcelRequire("epS7s");


var $hr2Qv = parcelRequire("hr2Qv");


var $2ok43 = parcelRequire("2ok43");


var $6CCa2 = parcelRequire("6CCa2");


var $cgtv4 = parcelRequire("cgtv4");

const $8b0984932526998a$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    placeholder: {
        id: "search_dialog_aria_label",
        defaultMessage: "Search"
    }
});


if (!window.inputSkeletonState) (0, $fG2rA.resetInputSkeletonState)();
const $816c13ddd7816a37$export$8f0d616c2469c6b6 = ({ onEnter: onEnter, isNav4Enabled: isNav4Enabled, injectValue: injectValue, customPlaceholder: customPlaceholder, inputRef: inputRef })=>{
    const dialogId = (0, $c0qxy.useId)();
    const { formatMessage: formatMessage, locale: locale } = (0, $8C5kA.default)();
    const initialSearchQuery = (0, $2ok43.getInitialQuery)();
    // Use the stored state as initial values for expansion and query
    const [isExpanded, setIsExpanded] = (0, $42omo.useState)((0, $fG2rA.getInputSkeletonFocus));
    const [value, setValue] = (0, $42omo.useState)(()=>injectValue ?? initialSearchQuery);
    const ghostTextData = (0, $42omo.useMemo)(()=>(0, $6CCa2.parseGhostTextData)(customPlaceholder, locale), [
        customPlaceholder,
        locale
    ]);
    const onFocus = (e)=>{
        setIsExpanded(true);
        (0, $fG2rA.setInputSkeletonIsFocus)(true);
        const target = e.currentTarget;
        (0, $fG2rA.setInputSkeletonSelection)(target.selectionStart || 0, target.selectionEnd || 0, target.selectionDirection || 'none');
    };
    const onBlur = ()=>{
        setIsExpanded(false);
        (0, $fG2rA.setInputSkeletonIsFocus)(false);
        (0, $fG2rA.setInputSkeletonSelection)(0, 0, 'none');
    };
    const onKeyDown = (e)=>{
        const target = e.currentTarget;
        if (e.key === 'Escape') {
            target.blur();
            onBlur();
        }
    };
    const onChange = (e)=>{
        const newValue = e.currentTarget.value;
        setValue(newValue);
        (0, $fG2rA.setInputSkeletonQuery)(newValue);
        const target = e.currentTarget;
        (0, $fG2rA.setInputSkeletonSelection)(target.selectionStart || 0, target.selectionEnd || 0, target.selectionDirection || 'none');
        (0, $epS7s.setSessionItem)((0, $epS7s.SEARCH_QUERY_KEY), newValue);
    };
    const onSelect = (e)=>{
        const target = e.currentTarget;
        (0, $fG2rA.setInputSkeletonSelection)(target.selectionStart || 0, target.selectionEnd || 0, target.selectionDirection || 'none');
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $hr2Qv.Textfield), {
        value: value,
        placeholder: (0, $dh538.fg)('quickfind-ghosttext') ? ghostTextData?.text ?? formatMessage((0, $8b0984932526998a$export$defe85febe8b728c).placeholder) : formatMessage((0, $8b0984932526998a$export$defe85febe8b728c).placeholder),
        dialogId: dialogId,
        quickFindOpen: isExpanded,
        onEnter: onEnter,
        onFocus: onFocus,
        onBlur: onBlur,
        onSelect: onSelect,
        onKeyDown: onKeyDown,
        onChange: onChange,
        isNav4Enabled: isNav4Enabled,
        inputRef: inputRef
    });
};
module.exports["QuickFindSkeleton"] = $816c13ddd7816a37$export$8f0d616c2469c6b6;

});

parcelRegister("fG2rA", function(module, exports) {
const $2e82d749b860510a$var$getWindow = ()=>typeof window !== 'undefined' ? window : null;
const $2e82d749b860510a$export$b8b6c2e7a0664212 = ()=>{
    return $2e82d749b860510a$var$getWindow()?.inputSkeletonState?.query ?? '';
};
const $2e82d749b860510a$export$baa1c819dd4691f3 = (newQuery)=>{
    const { inputSkeletonState: inputSkeletonState } = $2e82d749b860510a$var$getWindow() ?? {};
    if (inputSkeletonState) inputSkeletonState.query = newQuery;
};
const $2e82d749b860510a$export$38fcbc98be180790 = ()=>{
    return $2e82d749b860510a$var$getWindow()?.inputSkeletonState?.isFocused || false;
};
const $2e82d749b860510a$export$d3c6894b4e9af000 = (newIsFocused)=>{
    const { inputSkeletonState: inputSkeletonState } = $2e82d749b860510a$var$getWindow() ?? {};
    if (inputSkeletonState) inputSkeletonState.isFocused = newIsFocused;
};
const $2e82d749b860510a$export$a0c71b3bd9ec143c = ()=>{
    const { inputSkeletonState: inputSkeletonState } = $2e82d749b860510a$var$getWindow() ?? {};
    return {
        selectionStart: inputSkeletonState?.selectionStart ?? 0,
        selectionEnd: inputSkeletonState?.selectionEnd ?? 0,
        selectionDirection: inputSkeletonState?.selectionDirection ?? 'none'
    };
};
const $2e82d749b860510a$export$e0d745255b135363 = (newSelectionStart, newSelectionEnd, newSelectionDirection)=>{
    const { inputSkeletonState: inputSkeletonState } = $2e82d749b860510a$var$getWindow() ?? {};
    if (inputSkeletonState) {
        inputSkeletonState.selectionStart = newSelectionStart;
        inputSkeletonState.selectionEnd = newSelectionEnd;
        inputSkeletonState.selectionDirection = newSelectionDirection;
    }
};
const $2e82d749b860510a$export$c89dd2d5d4024c5e = ()=>{
    const safeWindow = $2e82d749b860510a$var$getWindow();
    if (safeWindow) safeWindow.inputSkeletonState = {
        query: '',
        placeholder: '',
        isFocused: false,
        selectionStart: 0,
        selectionEnd: 0,
        selectionDirection: 'none',
        listeners: []
    };
};
const $2e82d749b860510a$export$166ce39761ad7743 = ()=>{
    const { inputSkeletonState: inputSkeletonState } = $2e82d749b860510a$var$getWindow() ?? {};
    if (inputSkeletonState) {
        inputSkeletonState.listeners.forEach(([target, event, handler])=>{
            target.removeEventListener(event, handler);
        });
        inputSkeletonState.listeners = [];
    }
};
const $2e82d749b860510a$export$c830bcf42e072a93 = ()=>{
    $2e82d749b860510a$export$166ce39761ad7743();
    delete $2e82d749b860510a$var$getWindow()?.inputSkeletonState;
};
module.exports["getInputSkeletonQuery"] = $2e82d749b860510a$export$b8b6c2e7a0664212;
module.exports["setInputSkeletonQuery"] = $2e82d749b860510a$export$baa1c819dd4691f3;
module.exports["getInputSkeletonFocus"] = $2e82d749b860510a$export$38fcbc98be180790;
module.exports["setInputSkeletonIsFocus"] = $2e82d749b860510a$export$d3c6894b4e9af000;
module.exports["getInputSkeletonSelection"] = $2e82d749b860510a$export$a0c71b3bd9ec143c;
module.exports["setInputSkeletonSelection"] = $2e82d749b860510a$export$e0d745255b135363;
module.exports["resetInputSkeletonState"] = $2e82d749b860510a$export$c89dd2d5d4024c5e;
module.exports["removeInputSkeletonEventListeners"] = $2e82d749b860510a$export$166ce39761ad7743;
module.exports["removeInputSkeletonState"] = $2e82d749b860510a$export$c830bcf42e072a93;

});

parcelRegister("hr2Qv", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $8C5kA = parcelRequire("8C5kA");


var $1qfLF = parcelRequire("1qfLF");


var $hmuev = parcelRequire("hmuev");


var $jluld = parcelRequire("jluld");


var $dh538 = parcelRequire("dh538");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");




parcelRequire("42omo");





var $6fnsQ = parcelRequire("6fnsQ");

const $ede29c1f5665b53e$export$c3bd67ecc5ebe519 = ({ isExpanded: isExpanded, primaryColor: primaryColor = `var(--ds-text, ${0, $6fnsQ.N800})`, defaultColor: defaultColor = `var(--ds-text-subtlest, ${0, $6fnsQ.N200})`, label: label = '' })=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jluld))), {
        label: label,
        // NOTE: color do not accept string type but here primaryColor is string, so need to use any
        color: isExpanded ? primaryColor : defaultColor
    });



var $cgtv4 = parcelRequire("cgtv4");

const $3af5468bd2294d58$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    clearIconLabel: {
        id: "input_clear_icon_label",
        defaultMessage: "Clear search"
    },
    inputPlaceholder: {
        id: "input_placeholder",
        defaultMessage: "Search"
    },
    inputAriaLabel: {
        id: "input_aria_label",
        defaultMessage: "Search, press enter to navigate to advanced search with your text query"
    }
});


const $b91b1ab10826f40a$var$textFieldBoxStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center',
    height: 'size.300',
    ':focus': {
        height: 'size.400'
    },
    borderStyle: 'solid',
    borderWidth: 'border.width',
    borderColor: 'color.border',
    backgroundColor: 'elevation.surface.overlay',
    borderRadius: "var(--ds-radius-small, 4px)",
    paddingRight: 'space.200',
    width: '100%'
});
const $b91b1ab10826f40a$var$textFieldBoxStylesT26Shape = (0, $ecnYn.xcss)({
    borderRadius: 'radius.medium'
});
const $b91b1ab10826f40a$var$textFieldBoxFocusedStyles = (0, $ecnYn.xcss)({
    height: 'size.400',
    border: 'none',
    boxShadow: 'elevation.shadow.overlay',
    paddingRight: '0'
});
const $b91b1ab10826f40a$var$inputStyles = null;
const $b91b1ab10826f40a$var$inputFocusedStyles = null;
const $b91b1ab10826f40a$var$iconWrapperStyles = (0, $ecnYn.xcss)({
    minWidth: 'size.300',
    minHeight: 'size.300',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: 'color.text.subtlest'
});
const $b91b1ab10826f40a$var$iconWrapperFocusedStyles = (0, $ecnYn.xcss)({
    marginInlineStart: 'space.200',
    marginInlineEnd: 'space.150',
    minWidth: 'size.200'
});
const $b91b1ab10826f40a$var$clearIconStyles = (0, $ecnYn.xcss)({
    marginRight: 'space.100'
}); // Nav3 style overrides
// Can be removed once all supported products use Nav4
const $b91b1ab10826f40a$var$nav3StyleOverrides = {
    textFieldBoxStyles: (0, $ecnYn.xcss)({
        borderColor: 'color.border.input',
        backgroundColor: 'color.background.input',
        borderRadius: 'radius.medium',
        width: '200px'
    }),
    textFieldBoxFocusedStyles: (0, $ecnYn.xcss)({
        backgroundColor: 'elevation.surface.overlay',
        borderRadius: 'radius.large',
        width: '780px'
    }),
    iconWrapperStyles: (0, $ecnYn.xcss)({
        minWidth: '30px'
    }),
    inputStyles: null
};
const $b91b1ab10826f40a$export$d66ddc2063fc70a7 = ({ value: value, dialogId: dialogId, quickFindOpen: quickFindOpen, isNav4Enabled: isNav4Enabled, onEnter: onEnter, onFocus: onFocus, onBlur: onBlur, onSelect: onSelect, onKeyDown: onKeyDown, onChange: onChange, onClear: onClear, inputRef: inputRef, clearIconRef: clearIconRef, placeholder: placeholder })=>{
    const intl = (0, $8C5kA.default)();
    const handleKeyDown = (e)=>{
        if (!e.defaultPrevented && e.key === 'Enter') {
            e.preventDefault();
            onEnter && onEnter(e);
        }
        if (typeof onKeyDown === 'function') onKeyDown(e);
    };
    return(// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
        xcss: [
            $b91b1ab10826f40a$var$textFieldBoxStyles,
            (0, $dh538.fg)('platform-dst-shape-theme-default') && $b91b1ab10826f40a$var$textFieldBoxStylesT26Shape,
            quickFindOpen && $b91b1ab10826f40a$var$textFieldBoxFocusedStyles,
            !isNav4Enabled && $b91b1ab10826f40a$var$nav3StyleOverrides.textFieldBoxStyles,
            !isNav4Enabled && quickFindOpen && $b91b1ab10826f40a$var$nav3StyleOverrides.textFieldBoxFocusedStyles
        ],
        onClick: ()=>{
            inputRef?.current?.focus();
        },
        testId: "search-input-container",
        role: "search",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: [
                    $b91b1ab10826f40a$var$iconWrapperStyles,
                    quickFindOpen && $b91b1ab10826f40a$var$iconWrapperFocusedStyles,
                    !isNav4Enabled && $b91b1ab10826f40a$var$nav3StyleOverrides.iconWrapperStyles
                ],
                children: isNav4Enabled || quickFindOpen ? /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jluld))), {
                    color: "currentColor",
                    label: "",
                    "aria-hidden": "true"
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $ede29c1f5665b53e$export$c3bd67ecc5ebe519), {
                    isExpanded: !!quickFindOpen
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("input", {
                ref: inputRef,
                onFocus: onFocus,
                onBlur: onBlur,
                onSelect: onSelect,
                onKeyDown: handleKeyDown,
                placeholder: placeholder || intl.formatMessage((0, $3af5468bd2294d58$export$defe85febe8b728c).inputPlaceholder),
                onChange: onChange,
                value: value,
                "data-testid": "search-input",
                autoComplete: "off",
                "aria-label": intl.formatMessage((0, $3af5468bd2294d58$export$defe85febe8b728c).inputAriaLabel),
                "aria-expanded": quickFindOpen,
                "aria-controls": quickFindOpen ? dialogId : undefined,
                "aria-haspopup": "true",
                role: "combobox",
                className: (0, $gMc0m.default)([
                    "_12ji1r31 _1qu2glyw _12y31o36 _11q7glyw _11c8fhey _19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1reo15vq _18m915vq _syaz1rpy _1bsb1osq _1bto1l2s _o5721q9c _1idr1rpy",
                    quickFindOpen && "_syazi7uo",
                    !isNav4Enabled && "_11c8fhey"
                ])
            }),
            quickFindOpen && value && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $b91b1ab10826f40a$var$clearIconStyles,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                    ref: clearIconRef,
                    icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                            ...iconProps,
                            color: "var(--ds-icon, #292A2E)",
                            label: ""
                        }),
                    spacing: 'compact',
                    onClick: onClear,
                    label: intl.formatMessage((0, $3af5468bd2294d58$export$defe85febe8b728c).clearIconLabel),
                    appearance: "subtle",
                    testId: "search-input-clear-button"
                })
            })
        ]
    }));
};
module.exports["Textfield"] = $b91b1ab10826f40a$export$d66ddc2063fc70a7;

});

parcelRegister("2ok43", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $c6GJD = parcelRequire("c6GJD");


var $fG2rA = parcelRequire("fG2rA");

// The query is stored in module scope to persist across remounts
let $e39928e964cca707$var$initialQueryValue;
const $e39928e964cca707$export$ed7270bd966434af = (searchQueryParams)=>{
    const stickySearch = $e39928e964cca707$var$initialQueryValue;
    return (0, $c6GJD.default).initializeCalled() && (0, $c6GJD.default).getExperimentValue('platform_set_initial_search_query_state', 'isEnabled', false) && searchQueryParams || stickySearch || (0, $fG2rA.getInputSkeletonQuery)() || '';
};
const $e39928e964cca707$export$67de3a75cbe82e14 = ({ localQuery: localQuery, inputRef: inputRef })=>{
    // Focus input if skeleton is focused
    (0, $42omo.useEffect)(()=>{
        const skeletonFocused = (0, $fG2rA.getInputSkeletonFocus)();
        if (skeletonFocused) {
            const input = inputRef?.current;
            if (input) {
                input.focus();
                const { selectionStart: selectionStart, selectionEnd: selectionEnd, selectionDirection: selectionDirection } = (0, $fG2rA.getInputSkeletonSelection)();
                input.setSelectionRange(selectionStart, selectionEnd, selectionDirection);
            }
        }
        (0, $fG2rA.removeInputSkeletonState)();
    }, [
        inputRef
    ]);
    // Push local query to session storage
    (0, $42omo.useEffect)(()=>{
        // Update the module-scoped variable to make it available for remounts
        $e39928e964cca707$var$initialQueryValue = localQuery;
    }, [
        localQuery
    ]);
};
module.exports["getInitialQuery"] = $e39928e964cca707$export$ed7270bd966434af;
module.exports["useInputSkeleton"] = $e39928e964cca707$export$67de3a75cbe82e14;

});

parcelRegister("6CCa2", function(module, exports) {

var $gLLcz = parcelRequire("gLLcz");


var $dh538 = parcelRequire("dh538");


var $dS0qJ = parcelRequire("dS0qJ");

var $7f54826d8f69d9e8$export$6891b88a23696d = /*#__PURE__*/ function(GhostTextExperimentCohort) {
    GhostTextExperimentCohort["CONTROL"] = "control";
    GhostTextExperimentCohort["THREE_P"] = "3p";
    return GhostTextExperimentCohort;
}({});
const $7f54826d8f69d9e8$export$73fd7fc6fed7f9d9 = 3;
const $7f54826d8f69d9e8$export$4d19f25c7b83dd4a = (0, $gLLcz.z).object({
    /** The placeholder text to display */ text: (0, $gLLcz.z).string(),
    /** Number of times this text has been shown (0-2, resets after 3) */ occurrence: (0, $gLLcz.z).number().optional().default(0)
});
const $7f54826d8f69d9e8$export$9bcc9fe305679f00 = (0, $gLLcz.z).object({
    /** Unique key identifying the current ghost text set */ id: (0, $gLLcz.z).string(),
    /** Locale of the ghost text */ locale: (0, $gLLcz.z).string(),
    /** The placeholder text to display */ text: (0, $gLLcz.z).string(),
    /** Number of times this text has been shown (0-2, resets after 3) */ occurrence: (0, $gLLcz.z).number().optional().default(0)
});
const $7f54826d8f69d9e8$export$b18cd5530389e27a = (data)=>{
    try {
        const result = $7f54826d8f69d9e8$export$9bcc9fe305679f00.safeParse(data);
        return result.success;
    } catch  {
        return false;
    }
};
const $7f54826d8f69d9e8$export$bd8829925eef3cc2 = (customPlaceholder, locale)=>{
    if (!(0, $dh538.fg)('quickfind-ghosttext')) return undefined;
    if (!customPlaceholder) return undefined;
    if (!(0, $dS0qJ.isEnglishLocale)(locale) && !(0, $dh538.fg)('confluence_quick_find_ghost_text_i18n')) return undefined;
    if ((0, $dh538.fg)('confluence_quick_find_ghost_text_i18n')) try {
        const result = $7f54826d8f69d9e8$export$9bcc9fe305679f00.safeParse(JSON.parse(customPlaceholder));
        if (result.success) return result.data;
        return undefined;
    } catch  {
        return undefined;
    }
    try {
        const result = $7f54826d8f69d9e8$export$4d19f25c7b83dd4a.safeParse(JSON.parse(customPlaceholder));
        if (result.success) return result.data;
        return undefined;
    } catch  {
        return undefined;
    }
};
module.exports["GhostTextExperimentCohort"] = $7f54826d8f69d9e8$export$6891b88a23696d;
module.exports["ROTATION_THRESHOLD"] = $7f54826d8f69d9e8$export$73fd7fc6fed7f9d9;
module.exports["isGhostTextDataV2"] = $7f54826d8f69d9e8$export$b18cd5530389e27a;
module.exports["parseGhostTextData"] = $7f54826d8f69d9e8$export$bd8829925eef3cc2;

});

parcelRegister("dS0qJ", function(module, exports) {
const $c4d36ce3018afd80$export$3ea53827ed349b2e = (locale)=>{
    // English locale or starts with 'en-', `en-US`, `en-GB`, etc.
    return locale.toLowerCase().startsWith('en');
};
module.exports["isEnglishLocale"] = $c4d36ce3018afd80$export$3ea53827ed349b2e;

});

parcelRegister("kPjLK", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $boBbB = parcelRequire("boBbB");


var $kvBa6 = parcelRequire("kvBa6");


var $jlIaF = parcelRequire("jlIaF");


var $dPJCf = parcelRequire("dPJCf");


var $lI5WA = parcelRequire("lI5WA");


var $5bPOK = parcelRequire("5bPOK");

const $229b3ea505396609$export$b8e73441a24493f0 = (push)=>{
    return (e)=>{
        const input = e.target;
        input.blur();
        push(`${(0, $jlIaF.CONTEXT_PATH)}/search/?text=${input.value}`);
    };
};
const $229b3ea505396609$export$8f0d1b9ef0a8f67f = ({ theme: theme, shouldFillContainer: shouldFillContainer })=>{
    const intl = (0, $8C5kA.default)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const [isQuickFindEnabled] = (0, $5bPOK.useQuickFindEnabled)();
    // Quick Find refactor uses a very slightly different skeleton
    if (isQuickFindEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        testId: "quick-find-container",
        xcss: $229b3ea505396609$var$searchBarWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $229b3ea505396609$var$searchBarContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kvBa6.QuickFindSkeleton), {
        onEnter: $229b3ea505396609$export$b8e73441a24493f0(push)
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $boBbB.ProductSearchInputSkeletonInteractive), {
        theme: theme,
        placeholder: intl.formatMessage((0, $lI5WA.i18n).placeholder),
        onEnter: $229b3ea505396609$export$b8e73441a24493f0(push),
        shouldFillContainer: shouldFillContainer,
        stickySearchEnabled: true
    });
};
const $229b3ea505396609$var$searchBarWrapper = (0, $ecnYn.xcss)({
    position: 'relative',
    width: '200px',
    height: "var(--ds-space-500, 40px)"
});
const $229b3ea505396609$var$searchBarContainer = (0, $ecnYn.xcss)({
    position: 'absolute',
    top: 'space.0',
    right: 'space.0',
    bottom: 'space.0',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    zIndex: 'dialog'
});
module.exports["generateInteractiveSkeletonOnEnter"] = $229b3ea505396609$export$b8e73441a24493f0;
module.exports["InteractiveSearchInputSkeleton"] = $229b3ea505396609$export$8f0d1b9ef0a8f67f;

});

parcelRegister("boBbB", function(module, exports) {
/*
 * An interactive version of the search input skeleton which allows users to
 * type into the skeleton's input.  The state of the skeleton input is saved in
 * the browser's storage (specifically within window.inputSkeletonState).
 * On the first render of this component, this stored state is used as initial
 * an initial state. This behaviour allows one instance of this component
 * to be replaced by another and appear to seamlessly act as a single component.
 *
 * This component is intended to be used for client side rendering only.
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");





var $42omo = parcelRequire("42omo");


var $59aAc = parcelRequire("59aAc");


var $1IGQP = parcelRequire("1IGQP");


var $epS7s = parcelRequire("epS7s");


var $fG2rA = parcelRequire("fG2rA");

const $44070146e5ea5455$export$fca483ab36e9fec9 = ({ placeholder: placeholder, stickySearchEnabled: stickySearchEnabled, onEnter: onEnter, shouldFillContainer: shouldFillContainer })=>{
    // Initialise stored inputSkeletonState if necessary
    const checkedForInputSkeletonState = (0, $42omo.useRef)(false);
    if (!checkedForInputSkeletonState.current) {
        if (!window.inputSkeletonState) (0, $fG2rA.resetInputSkeletonState)();
        checkedForInputSkeletonState.current = true;
    }
    const searchInputRef = (0, $42omo.useRef)(null);
    // Use the stored state as initial values for expansion and query
    const [isExpanded, setIsExpanded] = (0, $42omo.useState)((0, $fG2rA.getInputSkeletonFocus)());
    const [value, setValue] = (0, $42omo.useState)(()=>{
        const stickySearchQuery = (0, $epS7s.getSessionItem)((0, $epS7s.SEARCH_QUERY_KEY));
        return stickySearchEnabled && stickySearchQuery ? stickySearchQuery : (0, $fG2rA.getInputSkeletonQuery)();
    });
    // Use the stored state to focus and set selection
    (0, $42omo.useLayoutEffect)(()=>{
        (0, $fG2rA.removeInputSkeletonEventListeners)();
        const isFoucsed = (0, $fG2rA.getInputSkeletonFocus)();
        const { selectionStart: selectionStart, selectionEnd: selectionEnd, selectionDirection: selectionDirection } = (0, $fG2rA.getInputSkeletonSelection)();
        if (isFoucsed) {
            searchInputRef?.current?.focus();
            searchInputRef?.current?.setSelectionRange(selectionStart, selectionEnd, selectionDirection);
        }
    }, []);
    const onFocus = ()=>{
        setIsExpanded(true);
        (0, $fG2rA.setInputSkeletonIsFocus)(true);
        searchInputRef?.current?.focus();
    };
    const onBlur = ()=>{
        setIsExpanded(false);
        (0, $fG2rA.setInputSkeletonIsFocus)(false);
        if (!stickySearchEnabled) {
            setValue('');
            (0, $fG2rA.setInputSkeletonQuery)('');
            (0, $fG2rA.setInputSkeletonSelection)(0, 0, 'none');
        }
    };
    const onKeyDown = (e)=>{
        if (e.key === 'Escape') {
            searchInputRef?.current?.blur();
            onBlur();
        }
    };
    const onInput = (newValue)=>{
        setValue(newValue);
        (0, $fG2rA.setInputSkeletonQuery)(newValue);
        (0, $fG2rA.setInputSkeletonSelection)(searchInputRef?.current?.selectionStart || 0, searchInputRef?.current?.selectionEnd || 0, searchInputRef?.current?.selectionDirection || 'none');
        if (stickySearchEnabled) (0, $epS7s.setSessionItem)((0, $epS7s.SEARCH_QUERY_KEY), newValue);
    };
    const onSelect = ()=>{
        (0, $fG2rA.setInputSkeletonSelection)(searchInputRef?.current?.selectionStart || 0, searchInputRef?.current?.selectionEnd || 0, searchInputRef?.current?.selectionDirection || 'none');
    };
    // Fixes some instances where callbacks would not be called when the search
    // input is clicked as the component is being destroyed
    (0, $42omo.useEffect)(()=>{
        let storedSearchInputRef = null;
        if (searchInputRef.current) storedSearchInputRef = searchInputRef.current;
        return ()=>{
            if (storedSearchInputRef) {
                (0, $fG2rA.setInputSkeletonQuery)(storedSearchInputRef.value);
                (0, $fG2rA.setInputSkeletonIsFocus)(document.activeElement === storedSearchInputRef);
                (0, $fG2rA.setInputSkeletonSelection)(storedSearchInputRef.selectionStart || 0, storedSearchInputRef.selectionEnd || 0, storedSearchInputRef.selectionDirection || 'none');
            }
        };
    }, []);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $59aAc.SearchAnchor), {
        isExpanded: isExpanded,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyDown: onKeyDown,
        shouldFillContainer: shouldFillContainer,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1IGQP.default), {
            "data-test-id": "search-dialog-input-skeleton-interactive",
            isExpanded: isExpanded,
            placeholder: placeholder,
            onInput: onInput,
            onSelect: onSelect,
            onEnter: onEnter,
            shouldFillContainer: shouldFillContainer,
            value: value,
            ref: searchInputRef
        })
    });
};


var $eSS4z = parcelRequire("eSS4z");

const $155caec2176ab352$export$e3798ad624b9f761 = (props)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $eSS4z.ThemeProvider), {
        partialSearchCSS: props.theme,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $44070146e5ea5455$export$fca483ab36e9fec9), {
            ...props
        })
    });
};
module.exports["ProductSearchInputSkeletonInteractive"] = $155caec2176ab352$export$e3798ad624b9f761;

});

parcelRegister("59aAc", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $kHWmv = parcelRequire("kHWmv");

const $6d5845bdb4f82d66$export$bc951697710bb35a = ({ children: children, onBlur: onBlur, onFocus: onFocus, onKeyDown: onKeyDown, isExpanded: isExpanded, shouldFillContainer: shouldFillContainer })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $kHWmv.SearchAnchorWrapper), {
        shouldFillContainer: shouldFillContainer,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kHWmv.AbsoluteContainer), {
            shouldFillContainer: shouldFillContainer,
            isExpanded: isExpanded,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kHWmv.SearchDialogAnchor), {
                onBlur: onBlur,
                onFocus: onFocus,
                onKeyDown: onKeyDown,
                isExpanded: isExpanded,
                shouldFillContainer: shouldFillContainer,
                children: children
            })
        })
    });
module.exports["SearchAnchor"] = $6d5845bdb4f82d66$export$bc951697710bb35a;

});

parcelRegister("kHWmv", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");


var $2azjJ = parcelRequire("2azjJ");


var $cStGJ = parcelRequire("cStGJ");

const $c67d2f3a7ec55770$export$36aa0f4a98890c96 = /*#__PURE__*/ (0, $cStGJ.default)('div', {
    target: "exl9bxq3"
})("", (props)=>{
    if (props.isExpanded) // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $9K4OG.css)({
        position: 'absolute',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        ...props.shouldFillContainer && {
            left: 0
        },
        right: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: (0, $2azjJ.zIndex).searchDialog
    });
    return {};
});
const $c67d2f3a7ec55770$export$f565ce1043dae7c9 = /*#__PURE__*/ (0, $cStGJ.default)('div', {
    target: "exl9bxq2"
})("position:relative;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>{
    if (props.isExpanded) // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $9K4OG.css)("@media screen and (max-width: ", (0, $2azjJ.dialogPageCentreWidth), "){ position:", props.shouldFillContainer ? 'static' : 'fixed', "; z-index:", (0, $2azjJ.zIndex).searchDialog, ";left:calc((100% - ", (0, $2azjJ.dialogWidth), ") / 2);;}@media screen and (max-width: ", (0, $2azjJ.dialogPageTakeoverWidth), "px){ ", props.shouldFillContainer && 'position: fixed;', ";top:0;right:0;bottom:0;left:0;display:flex;flex-direction:column;overflow:auto;}");
    return {};
});
const $c67d2f3a7ec55770$export$dfece74a62f1398d = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "exl9bxq1"
})("position:relative;@media screen and (min-width: ", (0, $2azjJ.dialogPageTakeoverWidth) + 1, "px){", (props)=>props.shouldFillContainer ? 'width: 100%;' : 'min-width: 200px;', ";}", (props)=>props.shouldFillContainer ? 'max-width: 780px;' : '', " width:", (0, $2azjJ.inputFieldHeight).px, ";height:", (0, $2azjJ.inputFieldHeight).px, ";");
const $c67d2f3a7ec55770$export$5566658d36f6ca7b = /*#__PURE__*/ (0, $cStGJ.default)($c67d2f3a7ec55770$export$dfece74a62f1398d, {
    target: "exl9bxq0"
})("height:", (props)=>props.isExpanded ? (0, $2azjJ.enlargedInputFieldHeight).px : (0, $2azjJ.inputFieldHeight).px, ";");
module.exports["AbsoluteContainer"] = $c67d2f3a7ec55770$export$36aa0f4a98890c96;
module.exports["SearchDialogAnchor"] = $c67d2f3a7ec55770$export$f565ce1043dae7c9;
module.exports["SearchAnchorWrapper"] = $c67d2f3a7ec55770$export$dfece74a62f1398d;
module.exports["EnlargedSearchAnchorWrapper"] = $c67d2f3a7ec55770$export$5566658d36f6ca7b;

});

parcelRegister("1IGQP", function(module, exports) {
$parcel$export(module.exports, "default", () => $5cab0d10eb6d5e5f$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $3gadb = parcelRequire("3gadb");


var $bPdpL = parcelRequire("bPdpL");


var $1qfLF = parcelRequire("1qfLF");


var $eSS4z = parcelRequire("eSS4z");


var $iSHbD = parcelRequire("iSHbD");


var $fwSxy = parcelRequire("fwSxy");




parcelRequire("42omo");





var $7yDmn = parcelRequire("7yDmn");

const $b59d0e1ff8d6de12$export$bde709da22d710bb = ({ theme: theme, showClearButton: showClearButton, onClear: onClear, allowChangeExpand: allowChangeExpand, clearSearchLabel: clearSearchLabel, toggleAISearchButton: toggleAISearchButton })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $fwSxy.InputBoxOverlayRight), {
        children: [
            showClearButton && /*#__PURE__*/ (0, $l998X.jsx)((0, $fwSxy.ClearIconWrapper), {
                ...theme,
                role: "button",
                onClick: onClear,
                onMouseEnter: ()=>{
                    allowChangeExpand?.(false);
                },
                onMouseLeave: ()=>{
                    allowChangeExpand?.(true);
                },
                tabIndex: 0,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7yDmn))), {
                    color: "currentColor",
                    label: clearSearchLabel || 'Clear search session'
                })
            }),
            toggleAISearchButton
        ]
    });
};


const $5cab0d10eb6d5e5f$var$MAX_INPUT_LENGTH = 500;
const $5cab0d10eb6d5e5f$export$55d7609a8f1eccd2 = ({ onInput: onInput, onClick: onClick, onEnter: onEnter, isExpanded: isExpanded, placeholder: placeholder, forwardRef: forwardRef, value: value, theme: theme, tooltipContent: tooltipContent, onBack: onBack, showClearButton: showClearButton, onClear: onClear, allowChangeExpand: allowChangeExpand, exitSearchLabel: exitSearchLabel, clearSearchLabel: clearSearchLabel, onSelect: onSelect, toggleAISearchButton: toggleAISearchButton, shouldFillContainer: shouldFillContainer, disableBoxShadow: disableBoxShadow, ariaLabelContent: ariaLabelContent })=>{
    const handleInput = (e)=>{
        if (onInput) onInput(e.currentTarget.value);
    };
    const handleClick = (e)=>{
        if (onClick) onClick(e);
    };
    const handleTabEnter = (e)=>{
        if (e.key === 'Enter' && onClick) onClick();
    };
    const handleKeyDown = (e)=>{
        if (e.nativeEvent?.isComposing || e.keyCode === 229) return;
        if (!e.defaultPrevented && e.key === 'Enter') {
            e.preventDefault();
            onEnter && onEnter(e);
        }
    };
    const handleSelect = (e)=>{
        if (onSelect) onSelect(e);
    };
    const TooltipComponent = tooltipContent && !isExpanded ? undefined : (0, $fwSxy.HiddenTooltip);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: tooltipContent,
        // NOTE: Types in React 18 have changed, `styled(TooltipPrimitive)` is no longer valid
        component: TooltipComponent,
        position: "bottom",
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $fwSxy.SearchInputContainer), {
            ...theme,
            shouldFillContainer: shouldFillContainer,
            isExpanded: isExpanded,
            role: "search",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $fwSxy.MobileSearchIconWrapper), {
                    isExpanded: isExpanded,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                        label: "Search",
                        onClick: handleClick,
                        icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $iSHbD.SearchIcon), {
                                theme: theme,
                                isExpanded: isExpanded
                            })
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $fwSxy.DesktopSearchIconWrapper), {
                    ...theme,
                    isExpanded: isExpanded,
                    onKeyPress: handleTabEnter,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iSHbD.SearchIcon), {
                        theme: theme,
                        isExpanded: isExpanded
                    })
                }),
                isExpanded && /*#__PURE__*/ (0, $l998X.jsx)((0, $fwSxy.ArrowIconWrapper), {
                    ...theme,
                    onClick: onBack,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bPdpL))), {
                        label: exitSearchLabel || 'Exit Search',
                        color: "currentColor"
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $fwSxy.SearchInputField), {
                    "data-test-id": "search-dialog-input",
                    onInput: handleInput,
                    onChange: handleInput,
                    onKeyDown: handleKeyDown,
                    onClick: handleClick,
                    onSelect: handleSelect,
                    isExpanded: isExpanded,
                    placeholder: placeholder,
                    ref: forwardRef || undefined,
                    value: value,
                    maxLength: $5cab0d10eb6d5e5f$var$MAX_INPUT_LENGTH,
                    "aria-label": ariaLabelContent || placeholder,
                    ...disableBoxShadow && {
                        style: {
                            boxShadow: 'none'
                        }
                    },
                    ...theme
                }),
                (showClearButton || !!toggleAISearchButton) && /*#__PURE__*/ (0, $l998X.jsx)((0, $b59d0e1ff8d6de12$export$bde709da22d710bb), {
                    theme: theme,
                    showClearButton: showClearButton,
                    onClear: onClear,
                    allowChangeExpand: allowChangeExpand,
                    clearSearchLabel: clearSearchLabel,
                    toggleAISearchButton: toggleAISearchButton
                })
            ]
        })
    });
};
var $5cab0d10eb6d5e5f$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef((props, ref)=>{
    const theme = (0, $eSS4z.useTheme)();
    return /*#__PURE__*/ (0, $l998X.jsx)($5cab0d10eb6d5e5f$export$55d7609a8f1eccd2, {
        ...props,
        theme: theme,
        forwardRef: ref
    });
});

});

parcelRegister("lI5WA", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $6ed75179671f755e$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    placeholder: {
        id: "navigation-search-dialog.placeholder",
        defaultMessage: "Search"
    },
    lastUpdatedDate: {
        id: "navigation-search-dialog.last-updated-date",
        defaultMessage: "Updated {datetime}"
    }
});
module.exports["i18n"] = $6ed75179671f755e$export$a7357cdd1f0b0168;

});

parcelRegister("blg7q", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $af81f9ffe316c2e0$export$69cf3fc83b854da4 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "4AEfs",
    name: "ConversationAssistantNavBarButton",
    loader: async ()=>(await (parcelRequire("4A0oq"))).ConversationAssistantNavBarButton
});
module.exports["ConversationAssistantNavBarButton"] = $af81f9ffe316c2e0$export$69cf3fc83b854da4;

});

parcelRegister("4A0oq", function(module, exports) {

let $355ad439a0720d51$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $355ad439a0720d51$var$load("fDEZX"),
    $355ad439a0720d51$var$load("kFEyO"),
    $355ad439a0720d51$var$load("31bKg"),
    $355ad439a0720d51$var$load("jbxHq"),
    $355ad439a0720d51$var$load("gryT8"),
    $355ad439a0720d51$var$load("hhss7"),
    $355ad439a0720d51$var$load("gM13h")
]).then(()=>parcelRequire('1RPPn'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});


//# sourceMappingURL=PageLayout.e499d6c8.js.map
